import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { TopSeedItem } from '@/types/seeds';

interface TopSeedsTableProps {
  seeds: TopSeedItem[];
}

export function TopSeedsTable({ seeds }: TopSeedsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-8">#</TableHead>
            <TableHead>Title</TableHead>
            <TableHead>Category</TableHead>
            <TableHead>Times Used</TableHead>
            <TableHead>Completion</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {seeds.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-muted-foreground">
                No usage data yet.
              </TableCell>
            </TableRow>
          ) : (
            seeds.map((s, i) => (
              <TableRow key={s.id}>
                <TableCell className="text-muted-foreground">{i + 1}</TableCell>
                <TableCell className="font-medium">{s.title}</TableCell>
                <TableCell>
                  <Badge variant="outline">{s.category}</Badge>
                </TableCell>
                <TableCell>{s.times_used}</TableCell>
                <TableCell>{s.completion_rate}%</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
